import Typography from "../Typography/Typography";
import { ChevronIcon } from "../icon";

export default function NexPaginationButton({}: {}) {
  return (
    <button className="bg-black w-8 h-8 rounded-[4px] flex items-center justify-center !text-white">
      <Typography type="span" customStyles="rotate-180 block">
        <ChevronIcon />
      </Typography>
    </button>
  );
}
